var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1627 2.086V3.15H7.5767V4.438H6.0787C5.92937 5.32467 5.5607 5.96867 4.9727 6.37C4.39404 6.77133 3.5167 6.972 2.3407 6.972V7.714C2.3407 8.15267 2.42937 8.498 2.6067 8.75C2.79337 9.002 3.10604 9.128 3.5447 9.128C3.9647 9.128 4.26804 9.01133 4.4547 8.778C4.64137 8.53533 4.7347 8.18533 4.7347 7.728H6.5547C6.53604 8.67067 6.27004 9.394 5.7567 9.898C5.24337 10.3927 4.5107 10.64 3.5587 10.64C2.56937 10.64 1.81337 10.374 1.2907 9.842C0.768036 9.31 0.506703 8.53533 0.506703 7.518V5.656C1.50537 5.656 2.2427 5.63267 2.7187 5.586C3.1947 5.53 3.54937 5.418 3.7827 5.25C4.01604 5.082 4.17004 4.81133 4.2447 4.438H0.0587027V3.15H4.3147V2.086H0.0587027V0.713998H7.5767V2.086H6.1627Z",
    fill: "#001A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.be771f3afeb9cdb0130f7f1ddf4343fa.svg";
export { ForwardRef as ReactComponent };